// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"f5c21aec","855":"f5c21aec"}[chunkId] + ".chunk.css";
};